
    const data = {"name":"src/core/icons/email-outline","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6m-2 0-8 5-8-5h16m0 12H4V8l8 5 8-5v10Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            